import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M21.5 20.1a.6.6 0 1 0 0-1.2h-19a.6.6 0 0 0 0 1.2h19Zm-10.1-5.6a.6.6 0 1 0 1.2 0V5.949l3.976 3.975a.6.6 0 0 0 .848-.848l-5-5a.6.6 0 0 0-.848 0l-5 5a.6.6 0 1 0 .848.848L11.4 5.95v8.55Z"
    />
  </svg>
`;
